<div *ngFor="let criterion of criteria" class="section">
  <div class="section-title page-break-before"
    [style]="{'padding-top': print ? '2rem' : ''}"
  >{{criterion.sectionTitle}}</div>
  <ion-accordion-group
    *ngFor="let i of criterion.criteria"
    [style]="{'padding-top': print ? '1rem !important' : '', 'border': print ? 'none !important' : ''}"
    [value]="getPanelState()"
  >
    <ion-accordion
      [value]="generatePanelId(criterion.sectionTitle, i.criterion)"
      [id]="generatePanelId(criterion.sectionTitle, i.criterion)"
      (click)="clearPanelState()"
    >
      <ion-item slot="header">
        <ion-label>
          <app-call-details-eval-card-row
            [evalPoint]="i"
            [header]="true"
          ></app-call-details-eval-card-row>
        </ion-label>
      </ion-item>
      <div slot="content" class="description-wrap">
        <div class="bold">{{ "__CALLS_AI_COACHING_QUESTION_1__" | translate }}</div>
        <div [innerHTML]="i.coaching | newline"></div>
        <div style="margin-top: 0.5rem;" class="bold">{{ "__CALLS_AI_COACHING_QUESTION_2__" | translate }}</div>
        <div class="scroll-end" [innerHTML]="i.improvement | newline"></div>
      </div>
    </ion-accordion>
  </ion-accordion-group>
</div>
